import { Button } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';

type ButtonProps = ComponentProps<typeof Button>;

export const LoadMoreButton = ({
  onClick,
  label = 'Load More Reviews',
}: Pick<ButtonProps, 'onClick'> & { label?: string }) => {
  return (
    <Button
      variant="outline"
      w="full"
      h={12}
      border="1px solid #3D1690"
      bg="generic.0"
      color="primary.500"
      textStyle="label.medium"
      fontWeight="normal"
      borderRadius="8px"
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

export default LoadMoreButton;
